import React from 'react';
import { X } from 'lucide-react';
import { KeyboardShortcut, getShortcutDisplay } from '../hooks/useKeyboardShortcuts';
interface KeyboardShortcutsHelpProps {
  shortcuts: KeyboardShortcut[];
  onClose: () => void;
}
export function KeyboardShortcutsHelp({
  shortcuts,
  onClose
}: KeyboardShortcutsHelpProps) {
  return <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" data-id="element-1351">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4" data-id="element-1352">
        <div className="flex items-center justify-between p-4 border-b" data-id="element-1353">
          <h2 className="text-lg font-semibold" data-id="element-1354">Keyboard Shortcuts</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors" data-id="element-1355">
            <X className="w-5 h-5" data-id="element-1356" />
          </button>
        </div>

        <div className="p-4 space-y-2 max-h-96 overflow-y-auto" data-id="element-1357">
          {shortcuts.map((shortcut, index) => <div key={index} className="flex items-center justify-between py-2" data-id="element-1358">
              <span className="text-sm text-gray-700" data-id="element-1359">
                {shortcut.description}
              </span>
              <kbd className="px-2 py-1 text-xs font-semibold text-gray-800 bg-gray-100 border border-gray-200 rounded" data-id="element-1360">
                {getShortcutDisplay(shortcut)}
              </kbd>
            </div>)}
        </div>

        <div className="p-4 border-t bg-gray-50 rounded-b-lg" data-id="element-1361">
          <p className="text-xs text-gray-500" data-id="element-1362">
            Press{' '}
            <kbd className="px-1 py-0.5 text-xs font-semibold bg-white border border-gray-200 rounded" data-id="element-1363">
              ?
            </kbd>{' '}
            to toggle this help
          </p>
        </div>
      </div>
    </div>;
}